import reactToCSS from "react-style-object-to-css";
import moment from "moment";


const formatter =(num, coin = false,replace="", decimals=2) => {
    return (
      (coin ? "$" : "") +
      Number(num)
        .toFixed(decimals)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        .replace(replace,"")
    );
  };

export const makeCSS = ({ css: _css_ }) => {
    const css = JSON.parse(JSON.stringify(_css_||{}))
    if(css.paddingVertical){
        css.paddingTop = css.paddingVertical
        css.paddingBottom = css.paddingVertical
        delete css.paddingVertical
    }
    if(css.paddingHorizontal){
        css.paddingLeft = css.paddingHorizontal
        css.paddingRight = css.paddingHorizontal
        delete css.paddingHorizontal
    }
    if(css.marginVertical){
        css.marginTop = css.marginVertical
        css.marginBottom = css.marginVertical
        delete css.marginVertical
    }
    if(css.marginHorizontal){
        css.marginLeft = css.marginHorizontal
        css.marginRight = css.marginHorizontal
        delete css.marginHorizontal
    }
  return reactToCSS(css || {});
}

export const formaters = type =>{
    return {
        moneda: (v, { decimales = 2, remplaso = "" }) =>
          formatter(v, 1, remplaso, decimales),
        number: v => formatter(v, 0, '.00'),
        numero: (v, { decimales = 2, remplaso = ".00" }) =>
          formatter(v, 0, remplaso, decimales),
        fecha: (v, { formato }) => moment(v, "YYYY-MM-DD").format(formato),
        price: v => formatter(v, 1),
        undefined: s => s
      }[type];
}
